import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import ApiService from "../../../ApiService";
import DispatchProps from "../../../../utils/DispatchProps";
import {IRootState} from "../../../../store";
import {Dictionary} from "lodash";
import LoadingCard from "../../../LoadingCard";
import * as _ from "lodash";
import MisConnectionDetailsEditor from "../../../mis-connection-details/MisConnectionDetailsEditor";
import {IMisConnectionDetailsResult} from "../../../../models/mis-connection-details/IMisConnectionDetailsResult";
import {CommandBarButton, Dropdown, IDropdownOption} from "office-ui-fabric-react";
import SchoolInfoHeader from '../../../SchoolInfoHeader';
import SchoolPageTitle from '../../../SchoolPageTitle';
import AdminSchoolMenu from '../../../AdminSchoolMenu';

interface MisConnectionDetailsSchoolPageProps {
    apiService: ApiService;

    tenantId:string;
    schoolCode:string;
}

interface MisConnectionDetailsSchoolPageState {
    details?: Dictionary<IMisConnectionDetailsResult>;
    misNamesWithDetails?: string[]
    misNamesWithoutDetails?: string[]
    
    selectedMisName?: string;
}

class MisConnectionDetailsSchoolPage extends Component<MisConnectionDetailsSchoolPageProps & DispatchProps, MisConnectionDetailsSchoolPageState> {
    static displayName = MisConnectionDetailsSchoolPage.name;

    constructor(props: MisConnectionDetailsSchoolPageProps & DispatchProps) {
        super(props);

        this.state = {
            details: undefined,
            selectedMisName: undefined
        }
    }

    async componentDidMount() {
        await this.getDetails();
    }

    async componentDidUpdate(prevProps: Readonly<MisConnectionDetailsSchoolPageProps & DispatchProps>, prevState: any): Promise<void> {
        
        if(this.state.details !== prevState.details && this.state.details !== undefined)
        {
            const misNamesWithoutDetails = Object.keys(this.state.details).filter(key => this.state.details![key] === null);
            const misNamesWithDetails = _.without(Object.keys(this.state.details),...misNamesWithoutDetails);
            
            this.setState({
                misNamesWithDetails,
                misNamesWithoutDetails
            });
        }
    }
    
    public async getDetails()
    {
        this.setState({
            details: undefined,
            misNamesWithDetails: undefined,
            misNamesWithoutDetails:undefined
        });
        
        const details = await this.props.apiService.getMisConnectionDetails(this.props.tenantId, this.props.schoolCode);

        this.setState({
            details
        });
    }
    
    private buildMisDropdown(): JSX.Element
    {
        const options: IDropdownOption[] = this.state.misNamesWithoutDetails!.map(misName => {
            return {
                text: misName,
                key: misName
            }
        });

        return (
            <Dropdown
                label="Add MIS"
                selectedKey={this.state.selectedMisName}
                onChange={(e,newValue) => {
                    this.setState({
                        selectedMisName: newValue?.key as string
                    });
                }}
                options={options}
            />
        );
    }

    
    render() {
        if(this.state.details === undefined || this.state.misNamesWithDetails === undefined || this.state.misNamesWithoutDetails === undefined)
        {
            return <LoadingCard/>;
        }
        
        
        const addMisCard = (
            <div key={"add"} className="card">

                <div className={"card__header"}>
                    <div className={"card__title"}>
                        <span>Add Mis Connection</span>
                    </div>
                    <CommandBarButton
                        text="Add MIS"
                        iconProps={{iconName: 'add'}}
                        onClick={async () => {

                            const blank = await this.props.apiService.getBlankMisConnectionDetails(this.props.tenantId, this.props.schoolCode, this.state.selectedMisName!);
                            const newDetails = _.cloneDeep(this.state.details);
                            newDetails![this.state.selectedMisName!] = blank;


                            this.setState({
                                details: newDetails,
                                selectedMisName: undefined
                            })
                        }}
                    />
                </div>

                <div className={"card__content"}>
                    {this.buildMisDropdown()}
                </div>
            </div>
        );


        const editors = this.state.misNamesWithDetails.map(misName => {
            return <MisConnectionDetailsEditor key={`${misName}-editor`} tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}
                                            misName={misName} details={this.state.details![misName]}
                                            apiService={this.props.apiService}
                                            onDeleted={() => this.getDetails()}
            />
        });

        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="MIS Connections" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <SchoolInfoHeader tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}/>
                {addMisCard}
                {editors}
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): MisConnectionDetailsSchoolPageProps => {
        return {
            apiService: state.auth.apiService,

            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
        };
    }
)(MisConnectionDetailsSchoolPage)